export default __webpack_public_path__ + "static/media/2.e5727ea7.png";